import styled from 'styled-components';
import { TextBlock } from '../text';
import { FontFamilyBold } from '../fonts';

export const TextDescription = styled(TextBlock)`
    padding: 0px 40px;
    margin-top: 30px;
`;

export const TextDescriptionMain = styled(TextDescription)`
    margin-top: 0px;
`;

export const TextExampleCode = styled(TextBlock)`
    color: ${props => props.theme.color.orange};
    ${FontFamilyBold};
    padding: 0px 40px;
    margin-top: 30px;
`;

export const TextExampleCodeValue = styled(TextBlock)`
    padding: 0px 40px;
`;

export const IconsContainer = styled.div`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    padding: 0px 40px;
    ${props => props.theme.mediaQueries.phone} {
        flex-direction: column;
        align-items: center;
        flex-wrap: nowrap;
    }
`;

export const IconContainer = styled.div`
    width: 100%;
    max-width: 136px;
    margin-right: 10px;
    margin-left: 10px;
`;

export const TextDescriptionIcon = styled(TextBlock)`
    
`;
